// extracted by mini-css-extract-plugin
export var banner = "_gv-0";
export var closeButton = "_gv-2";
export var greenCheckmark = "_gv-3";
export var hereLink = "_gv-4";
export var titleIcon = "_gv-1";